<template>
  <div class="bon-page">
    <Toast />

    <div class="card">
      <div class="card-header">
        <h5 class="card-title">Buat Bon</h5>
      </div>

      <div class="card-body">
        <DataTable
          :value="warehouse_outbounds"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
          :loading="loading.filter"
          :rowHover="true"
          :selection.sync="selected_items"
          class="p-datatable-sm"
          responsiveLayout="scroll"
        >
          <template #empty>
            <div class="text-center p-4">
              <i class="pi pi-search mb-3" style="font-size: 2rem"></i>
              <p>Data tidak tersedia.</p>
            </div>
          </template>

          <template #header>
            <div class="filter-container">
              <div class="field outlet-field">
                <label for="outlet" class="block mb-1">Pilih Toko</label>
                <AutoComplete
                  id="outlet"
                  v-model="outlet_selected"
                  :suggestions="outlets"
                  @complete="searchOutlets($event)"
                  @input="onInputOutlet()"
                  field="name"
                  placeholder="Cari toko..."
                  :dropdown="true"
                  class="outlet-dropdown"
                  :class="{ 'p-invalid': is_error.outlet }"
                >
                  <template #item="slotProps">
                    <div class="outlet-item">
                      <span class="outlet-text"
                        >{{ slotProps.item.code }} -
                        {{ slotProps.item.name }}</span
                      >
                    </div>
                  </template>
                </AutoComplete>
                <small class="p-error" v-if="is_error.outlet">{{
                  error_msg.outlet
                }}</small>
              </div>
            </div>
          </template>

          <Column field="cat_no" header="No" headerStyle="width: 3em">
            <template #body="slotProps">
              {{ warehouse_outbounds.indexOf(slotProps.data) + 1 }}
            </template>
          </Column>

          <Column header="Kode Barang" headerStyle="width: 12em">
            <template #body="slotProps">
              <span class="font-medium">{{ slotProps.data.item_code }}</span>
            </template>
          </Column>

          <Column header="Nama Barang">
            <template #body="slotProps">
              <span class="text-truncate">{{ slotProps.data.item_name }}</span>
            </template>
          </Column>

          <Column header="Harga">
            <template #body="slotProps">
              <span class="text-right font-medium">{{
                slotProps.data.price | currency
              }}</span>
            </template>
          </Column>

          <Column header="Jumlah">
            <template #body="slotProps">
              <span class="text-right font-medium">{{
                slotProps.data.qty
              }}</span>
            </template>
          </Column>

          <Column selectionMode="multiple" headerStyle="width: 3em" />
        </DataTable>

        <div
          class="p-grid p-justify-center p-mt-4"
          v-if="warehouse_outbounds.length > 0 && selected_items.length > 0"
        >
          <div class="p-col-12 p-md-6 p-lg-3">
            <Button
              label="Buat BON"
              icon="pi pi-file"
              @click="generateBON()"
              class="p-button-primary w-100"
            />
          </div>
        </div>
      </div>
    </div>

    <Dialog
      :visible.sync="generate_dialog"
      :style="{ width: '450px' }"
      header="Generate BON"
      :modal="true"
      class="p-fluid"
    >
      <div class="confirmation-content">
        <i class="pi pi-file p-mr-3" style="font-size: 2rem" />
        <span>Silakan klik OK untuk membuat Bon</span>
      </div>
      <template #footer>
        <Button
          label="Batal"
          icon="pi pi-times"
          class="p-button-text"
          @click="generate_dialog = false"
        />
        <Button
          label="OK"
          icon="pi pi-check"
          class="p-button-text"
          @click="postOutletInbounds()"
          :loading="loading.generate"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      generate_dialog: false,

      loading: {
        filter: false,
        generate: false
      },

      outlets: [],
      outlet_filtered: [],
      outlet_selected: null,

      warehouse_outbounds: [],
      selected_items: [],

      warehouse_outbounds_id: [],
      status: '',

      is_error: {
        outlet: false
      },

      error_msg: {
        outlet: ''
      }
    }
  },
  mounted() {
    this.getOutlets()
  },
  methods: {
    async getOutlets() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/outlets`,
          {
            params: {
              status: 1
            }
          }
        )

        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Gagal mengambil data toko',
            life: 3000
          })
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Terjadi kesalahan saat mengambil data toko',
          life: 3000
        })
      }
    },

    async searchOutlets(event) {
      try {
        const searchParam =
          this.outlet_selected instanceof Object
            ? this.outlet_selected.code
            : this.outlet_selected
            ? this.outlet_selected
            : ''

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/outlets`,
          {
            params: {
              status: 1,
              search: searchParam,
              limit: 5
            }
          }
        )

        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        }

        this.outlet_filtered = this.outlets.filter(item => {
          return (
            item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
            item.code.toLowerCase().startsWith(event.query.toLowerCase())
          )
        })
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal mencari toko',
          life: 3000
        })
      }
    },

    onInputOutlet() {
      if (this.outlet_selected && this.outlet_selected.id) {
        this.getWarehouseOutbounds()
      }
    },

    async getWarehouseOutbounds() {
      this.loading.filter = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds`,
          {
            params: {
              outlet_id: this.outlet_selected.id,
              status: 1
            }
          }
        )

        if (response.status === 200) {
          this.warehouse_outbounds = response.data.data.warehouse_outbound
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Gagal mengambil data barang',
            life: 3000
          })
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Terjadi kesalahan saat mengambil data barang',
          life: 3000
        })
      } finally {
        this.loading.filter = false
      }
    },

    generateBON() {
      if (!this.selected_items.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Peringatan',
          detail: 'Pilih minimal satu barang',
          life: 3000
        })
        return
      }

      this.generate_dialog = true
      this.warehouse_outbounds_id = this.selected_items.map(item => item.id)
    },

    async postOutletInbounds() {
      this.loading.generate = true
      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/distribution`,
          { warehouse_outbounds_id: this.warehouse_outbounds_id }
        )

        this.generate_dialog = false
        if (response.status === 200) {
          this.$toast.add({
            severity: 'success',
            summary: 'Sukses',
            detail: 'Bon berhasil dibuat',
            life: 3000
          })
          this.$router.push({
            name: 'bon-detail',
            query: { doc_number: response.data.data.doc_number }
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Gagal membuat Bon',
            life: 3000
          })
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Terjadi kesalahan saat membuat Bon',
          life: 3000
        })
      } finally {
        this.loading.generate = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bon-page {
  .card {
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);

    .card-header {
      padding: 1.5rem;
      border-bottom: 1px solid #dee2e6;

      .card-title {
        margin: 0;
        font-size: 1.5rem;
        font-weight: 600;
        color: #495057;
        display: flex;
        align-items: center;

        i {
          color: #2196f3;
        }
      }
    }

    .card-body {
      padding: 1.5rem;
    }
  }

  .filter-container {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .field {
    margin-bottom: 0;

    &.outlet-field {
      width: 300px;
    }

    label {
      font-weight: 500;
      color: #495057;
      font-size: 0.875rem;
      margin-bottom: 0.25rem;
    }
  }

  .outlet-dropdown {
    width: 100%;
    min-width: 250px;
    max-width: 300px;
  }

  .outlet-item {
    padding: 0.5rem;
    display: block;

    .outlet-text {
      font-size: 0.875rem;
      color: #495057;

      .outlet-code {
        font-weight: 500;
        color: #2196f3;
      }
    }
  }

  .text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
    display: inline-block;
  }

  .text-right {
    text-align: right;
  }

  .font-medium {
    font-weight: 500;
  }

  .w-100 {
    width: 100%;
  }

  :deep(.p-datatable) {
    .p-datatable-thead > tr > th {
      background-color: #f8f9fa;
      padding: 0.75rem;
      font-size: 0.875rem;
      font-weight: 600;
      color: #495057;
    }

    .p-datatable-tbody > tr > td {
      padding: 0.75rem;
      font-size: 0.875rem;
    }

    .p-datatable-tbody > tr:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }

    .p-datatable-tbody > tr.p-highlight {
      background-color: #e3f2fd;
      color: #1976d2;

      .font-medium {
        color: #1976d2;
      }

      .text-truncate {
        color: #1976d2;
      }

      .text-right {
        color: #1976d2;
      }
    }
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;

    i {
      color: #2196f3;
      margin-right: 1rem;
    }
  }
}
</style>
